import AuctionHouseAuctionsList from "./AuctionHouseAuctionsList";

export default AuctionHouseAuctionsList;
